import Meta from 'src/components/meta/Meta';

const ComplaintsMeta = () => <Meta
  title="Have a Complaint? | BrickX"
  description="We hope you never have cause to do so, but if you have a complaint please email us at info@brickx.com"
/>;

export default ComplaintsMeta;
